import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
    const isAuthenticated = sessionStorage.getItem("isAuthenticated");

    // Se non autenticato → redirect a login
    if (!isAuthenticated || isAuthenticated !== "true") {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default ProtectedRoute;
